import { DOCUMENT_TYPES, type DocumentType } from '@horof/shared';

/** The library's filters, kept in the address (bookmarkable). */
export const DOCUMENT_FILTER_KEYS = [
  'type',
  'q',
  'year',
  'project',
  'counterparty',
  'waiting',
] as const;

/**
 * The address's filters as arqam's `AssociationDocumentFilter`. «waiting»:
 * letters whose reply date has passed with no reply linked.
 */
export function documentsFilter(params: URLSearchParams, today: string) {
  const and: Record<string, unknown>[] = [];
  const type = params.get('type');
  if (type && DOCUMENT_TYPES.includes(type as DocumentType)) {
    and.push({ type: { equalTo: type } });
  }
  const year = params.get('year');
  if (year && /^\d{4}$/.test(year)) {
    and.push({
      documentDate: {
        greaterThanOrEqualTo: `${year}-01-01`,
        lessThanOrEqualTo: `${year}-12-31`,
      },
    });
  }
  const project = params.get('project');
  if (project) and.push({ projectId: { equalTo: project } });
  const counterparty = params.get('counterparty');
  if (counterparty) and.push({ counterpartyId: { equalTo: counterparty } });
  const q = params.get('q')?.trim();
  if (q) {
    and.push({
      or: [
        { title: { includesInsensitive: q } },
        { reference: { includesInsensitive: q } },
      ],
    });
  }
  if (params.get('waiting')) {
    and.push({
      replyDueOn: { lessThan: today },
      repliedById: { isNull: true },
    });
  }
  return and.length ? { and } : null;
}
